interface Person {
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  email: string;
}

/** First and last name of a person, or the email of one nobody named. */
export const personName = (person: Person): string =>
  [person.firstName, person.lastName].filter(Boolean).join(" ") || person.email;
